function getThrowIndicator(result) {
  switch (result) {
    case 0:
      return "🚫";
    case 1:
      return "⛓️";
    case 2:
      return "✔️";
    default:
      return "\u00A0"; // Non-breaking space to maintain cell height
  }
}

export default getThrowIndicator;
